import { render } from "./HeroiconsSolidFlag.vue?vue&type=template&id=1c35213d"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidFlag.vue"]])

export default __exports__